<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header header class="font-semibold" [title]="'success_alt_text' | translate">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <img
        class="success-image"
        src="/assets/images/success.svg"
        [alt]="offer?.getType() + '_successful' | translate" />
      @if (!isLeveragedToken) {
        <div class="success-headline mb-15">{{
          offer?.getType() + "_successful" | translate
        }}</div>
      }
      @if (isLeveragedToken) {
        <div class="success-headline mb-15">{{
          "leveraged_token_success_title" | translate
        }}</div>
      }
      <!-- normal asset -->
      @if (!isIndexTrade() && !isLeveragedToken) {
        <p
          class="text-center mb-15 font-size-17 translation-helper"
          >
          <span>{{ offer?.getType() + "_success_text" | translate }}</span>
          <br />
          <strong>
            {{
            (offer?.bestFeeOptIn ? offer?.getAmountAssetBfc() : offer?.getAmountTradable())
            | tradable_precision_symbol
            : {
            id: offer?.getCurrencyId(),
            currencies: [getTradable()],
            addName: true,
            dustThreshold: 0.0001
          }
          }}
        </strong>
        @if (isToken()) {
          {{ "fma_of" | translate: null : true }}
          {{ getTradable().getName() }}
        }
        {{ "for_success_screen" | translate }}
        <strong>
          {{
          (offer?.bestFeeOptIn ? offer?.getAmountFiatBfc() : offer?.getAmountFiat())
          | fiat_precision_symbol: { id: offer?.getFiatId(), currencies: [getFiat()], symbol: true }
          }}
        </strong>
        &#64;
        <strong>
          {{
          1
          | tradable_precision_symbol
          : {
          id: offer?.getCurrencyId(),
          currencies: [getTradable()],
          addName: true,
          removePrecision: true
        }
        }}
        =
        {{
        (offer?.bestFeeOptIn ? offer?.getPriceBfc() : offer?.getPrice())
        | fiat_precision_symbol
        : { id: offer?.getFiatId(), currencies: [getFiat(), getTradable()], symbol: true }
        }}
      </strong>
      @if (isCashPlusSubscribed$ | async) {
        {{ "cash_plus_success_additional" | translate }}
      }
    </p>
  } @else {
    @if (isIndexTrade()) {
      <p class="text-center mb-15 font-size-17 translation-helper">
        <span
							[innerHTML]="
								offer?.getType() + '_index_success'
									| translate
										: [
												offer?.getAmountFiat()
													| fiat_precision_symbol
														: {
																id: offer?.getFiatId(),
																currencies: [getFiat()],
																symbol: true
														  },
												getTradable().getName()
										  ]
										: false
							"></span>
        @if (isCashPlusSubscribed$ | async) {
          {{ "cash_plus_success_additional" | translate }}
        }
      </p>
    }
    @if (isLeveragedToken) {
      <p class="text-center mb-15 font-size-17 translation-helper">
        <span>
          {{
          "leverage_token_success_subtext_" + leveragedTokenSuffix
          | translate
          : [
          getTradable().getName(),
          offer?.getAmountFiat()
          | fiat_precision_symbol
          : {
          id: offer?.getFiatId(),
          currencies: [getFiat()],
          symbol: true
          },
          offer?.getAmountTradable()
          | tradable_precision_symbol
          : { id: offer?.getCurrencyId(), symbol: true }
          ]
          : false
          }}
        </span>
        @if (isCashPlusSubscribed$ | async) {
          {{ "cash_plus_success_additional" | translate }}
        }
      </p>
    }
  }
  <!-- BFC -->
  @if (showBfcInfoBox()) {
    <div class="additional-gain">
      <span class="bpi__asset-placeholdericon bpi__asset-best font-size-24 mr-10"></span>
      <span class="description">
        {{
        getBfcInfoText()
        | translate
        : [
        offer?.getAssetBonusBfc()
        | tradable_precision_symbol
        : {
        id: getTradable().getId(),
        ignorePrecision: true,
        addName: true
      }
      ]
      }}
    </span>
    @if (isCashPlusSubscribed$ | async) {
      {{ "cash_plus_success_additional" | translate }}
    }
  </div>
}

@if (+itbAmount > 0) {
  <!-- Info box -->
  <span class="center-block mb-20">
    <instant-trade-bonus [amount]="itbAmount" [step]="ITBStep.SUCCESS" [showLoading]="showItbLoading">
    </instant-trade-bonus>
  </span>
}
<!-- Tax withholding info currencies -->
@if (taxWithheld; as tax) {
  <tax-success-amount-label-ui [taxWithheld]="tax"></tax-success-amount-label-ui>
}

<!-- Taxes Temporary info -->
@if (taxWithheld?.isTaxServiceAvailable === false && +taxWithheld?.taxAmountFiat > 0) {
  <span
    class="temporary-tax"
    >
    <img [src]="'/assets/images/success-taxes-warning.svg'" [alt]="'alt_text' | translate" />
    {{ "tw_success_screen_temporary" | translate }}
  </span>
}

<!-- Vision banner -->
@let visionId = visionId$ | async;
@let isUkUser = isUkUser$ | async;
@if (
  (visionFeeFlag$ | async) &&
  !isUkUser &&
  offer?.getVsnFeeTokenCollection()?.globalOptIn !== null &&
  (offer?.getVsnFeeTokenCollection()?.eligibleForVsn || offer?.getCurrencyId() === visionId.getId()) &&
  (offer?.getVsnFeeTokenCollection()?.globalOptIn === false ||
  (offer?.getVsnFeeTokenCollection()?.globalOptIn &&
  offer?.getVsnFeeTokenCollection()?.visionFeeDetail?.hasEnoughFunds === false))
  ) {
  <div class="vision-banner-container">
    <mo-success-vision-component
      [bannerState]="getVisionBannerState()"
      [feeAmount]="offer.getVsnFeeTokenCollection().feeDiscount"
    (click)="handleBannerClick()"></mo-success-vision-component>
  </div>
}
<!-- C+ should be removed in UK, comment for next sync -->
<div class="mb-50 text-center">
  <a (click)="goToWallet()">{{ "go-to-wallet" | translate }}</a>
</div>
<!-- go to wallet -->

@if (!isIndexTrade()) {
  <div class="mb-30 text-center">
    <button
      (click)="addPriceAlert()"
      class="btn btn-primary btn-success-modal mod-middle button-weight"
      type="button">
      {{ "add_pricealert" | translate: [getTradable().getSymbol(false, true)] }}
    </button>
  </div>
}
</div>
<div class="text-center">
  <button (click)="goToPortfolio()" class="btn btn-primary btn-success-modal" type="button">
    <strong>{{ "go_to_portfolio" | translate }}</strong>
  </button>
</div>
</div>
</success-screen>
